import { t } from "@lingui/core/macro";

/**
 * The way a body of timber is cut up for a chart.
 *
 * Each dimension has its own measure, because the question each one answers
 * is a different one:
 * - `buyer`: who bought the timber, over what left the storage
 * - `contractor`: who harvested the timber, over everything the cutting produced
 * - `contractorUser`: who shipped the timber, over what left the storage
 * - `forestOwner`: whose forest the timber came from, over everything the cutting produced
 */
export type SplitDimension = 'buyer' | 'contractor' | 'contractorUser' | 'forestOwner';

export interface SplitRow {
    key: string,
    label: string,
    volume: number,
    /** The share of the total, in percent. */
    share: number,
    /** The share of everything above it, in percent. */
    cumulative: number,
}

export interface SplitResult {
    dimension: SplitDimension,
    /** What the volumes are: the timber that left the storage, or everything that was produced. */
    measure: 'shipped' | 'produced',
    total: number,
    rows: SplitRow[],
}

export interface SplitRequest {
    dimension: SplitDimension,
}

export const splitDimensions: {id: SplitDimension, label: string}[] = [
    {id: 'buyer', label: t`Buyers`},
    {id: 'contractor', label: t`Contractors`},
    {id: 'contractorUser', label: t`Contractor users`},
    {id: 'forestOwner', label: t`Forest owners`},
];
